  import React, { useState, useEffect } from 'react';
  import { Form, Input, Button, InputNumber, notification, Row, Col, Select, Typography, Divider, DatePicker } from 'antd';
  import moment from 'moment';


  const { Option } = Select;
  const { Title } = Typography;

  const InvoiceForm = () => {
    const [form] = Form.useForm();
    const [products, setProducts] = useState([]);
    const [productOptions, setProductOptions] = useState([]);
    const [count, setCount] = useState(0);
    const [totalAmount, setTotalAmount] = useState(0);
    const [customers, setCustomers] = useState([]);
    const [invoiceDate, setInvoiceDate] = useState(moment());
    const [invoiceNumber, setInvoiceNumber] = useState('');
    const [filteredProductOptions, setFilteredProductOptions] = useState(productOptions);
    const [filteredCustomerOptions, setFilteredCustomerOptions] = useState(customers);

    const [customerAccounts, setCustomerAccounts] = useState([]);
    const [selectedAccount, setSelectedAccount] = useState(null);
    const [forInvoiceAmount, setForInvoiceAmount] = useState();
    const [froInvoiceAmount, setFroInvoiceAmount] = useState(0);
    const [differenceAmount, setDifferenceAmount] = useState(0);
    const [gstAmount, setGstAmount] = useState(0); // Replace gst_percentage with gstAmount


    useEffect(() => {
      const difference = Math.abs(froInvoiceAmount - totalAmount);
      setDifferenceAmount(difference);
    }, [froInvoiceAmount, totalAmount]);


    const handleSearch = (value) => {
      if (value) {
        const filteredProducts = productOptions.filter(product =>
          product.name.toLowerCase().includes(value.toLowerCase())
        );
        setFilteredProductOptions(filteredProducts);
      } else {
        setFilteredProductOptions(productOptions);
      }
    };

      // Modified incrementInvoiceNumber function
  const incrementInvoiceNumber = (currentInvoiceNumber) => {
    const match = currentInvoiceNumber.match(/^CHALLAN(\d+)$/i);
    if (match) {
      const currentNumber = parseInt(match[1], 10);
      const nextNumber = (currentNumber + 1).toString().padStart(3, '0');
      return `CHALLAN${nextNumber}`;
    }
    return 'CHALLAN001'; // Default if format doesn't match
  };


    const handleSearchCustomer = (value) => {
      if (value) {
        const filteredCustomers = customers.filter(customer =>
          customer.name.toLowerCase().includes(value.toLowerCase())
        );
        setFilteredCustomerOptions(filteredCustomers);
      } else {
        setFilteredCustomerOptions(customers);
      }
    };


useEffect(() => {
  const fetchLastInvoiceNumber = async () => {
    try {
      const response = await fetch('https://chalan.eoptilab.com/backend/get_last_invoice_number.php');
      const result = await response.json();
      if (result.success && result.lastInvoiceNumber) {
        const nextInvoiceNumber = incrementInvoiceNumber(result.lastInvoiceNumber);
        setInvoiceNumber(nextInvoiceNumber);
        localStorage.setItem('invoiceNumber', nextInvoiceNumber);
      } else {
        const defaultInvoiceNumber = 'CHALLAN001';
        setInvoiceNumber(defaultInvoiceNumber);
        localStorage.setItem('invoiceNumber', defaultInvoiceNumber);
      }
    } catch (error) {
      console.error('Failed to fetch last invoice number:', error);
      const defaultInvoiceNumber = 'CHALLAN001';
      setInvoiceNumber(defaultInvoiceNumber);
      localStorage.setItem('invoiceNumber', defaultInvoiceNumber);
    }
  };

  fetchLastInvoiceNumber();

}, [])



    useEffect(() => {
      const fetchCustomers = async () => {
        try {
          const response = await fetch('https://chalan.eoptilab.com/backend/get_customer.php');
          const result = await response.json();
          if (result.success) {
            setCustomers(result.data);
            setFilteredCustomerOptions(result.data);  // Initialize filtered options
          } else {
            notification.error({
              message: 'Error',
              description: result.message,
            });
          }
        } catch (error) {
          notification.error({
            message: 'Error',
            description: 'Failed to fetch customers',
          });
        }
      };

      const fetchProducts = async () => {
        try {
          const response = await fetch('https://chalan.eoptilab.com/backend/get_product.php');
          const result = await response.json();
          if (result.success) {
            setProductOptions(result.data);
          } else {
            notification.error({
              message: 'Error',
              description: result.message,
            });
          }
        } catch (error) {
          notification.error({
            message: 'Error',
            description: 'Failed to fetch products',
          });
        }
      };

      fetchCustomers();
      fetchProducts();

      const savedInvoiceNumber = localStorage.getItem('invoiceNumber');
      if (savedInvoiceNumber) {
        setInvoiceNumber(savedInvoiceNumber);
      } else {
        const defaultInvoiceNumber = 'CHALLAN001';  // You can set this to whatever format you prefer
        localStorage.setItem('invoiceNumber', defaultInvoiceNumber);
        setInvoiceNumber(defaultInvoiceNumber);
      }
    }, []);
    useEffect(() => {
      // Calculate the total amount from products
      const computedTotal = products.reduce((total, product) => {
        return total + (product.quantity * product.price);
      }, 0);

      // Get the discount percentage from the form (default to 0 if not provided)
      const discountPercentage = form.getFieldValue('default_discount') || 0;

      // Calculate the discount amount as a percentage of the total
      const discountAmount = (discountPercentage / 100) * computedTotal;

      // Calculate final total by adding GST amount and subtracting discount
      setTotalAmount(computedTotal - discountAmount + gstAmount);
    }, [products, gstAmount, form]); // Update dependency array to use gstAmount
    const addProduct = () => {
      setProducts([...products, { key: count, product: '', quantity: 1, price: 0 }]);
      setCount(count + 1);
    };

    const handleProductChange = (key, field, value) => {
      setProducts(products.map(p =>
        p.key === key ? { ...p, [field]: value } : p
      ));
    };
    const handleRemoveProduct = (key) => {
      // Assuming you have a state management for products
      setProducts(prevProducts => prevProducts.filter(product => product.key !== key));
    };
    const handleAccessoriesChange = (category) => {
      const account = customerAccounts.find(acc => acc.category === category);
      if (account) {
        setSelectedAccount(account);
        updateFormWithAccountDetails(account);
      }
    };

    const updateFormWithAccountDetails = (account) => {
      form.setFieldsValue({
        address: account.address,
        number: account.number,
        state: account.state,
        default_discount: account.default_discount,
        category: account.category
      });
    };
    const handleCustomerChange = async (customerName) => {
      try {
        const response = await fetch('https://chalan.eoptilab.com/backend/get_customer.php', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ name: customerName }),
        });
        const result = await response.json();
        if (result.success) {
          // Assuming the API now returns an array of accounts for the customer
          setCustomerAccounts(result.data);

          // If there's only one account, set it automatically
          if (result.data.length === 1) {
            const account = result.data[0];
            setSelectedAccount(account);
            updateFormWithAccountDetails(account);
          } else {
            // Clear the form if multiple accounts exist
            form.setFieldsValue({
              address: '',
              number: '',
              state: '',
              default_discount: '',
              category: ''
            });
          }
        } else {
          notification.error({
            message: 'Error',
            description: result.message,
          });
        }
      } catch (error) {
        notification.error({
          message: 'Error',
          description: 'Failed to fetch customer details',
        });
      }
    };

    const handleProductSelect = (key, productName) => {
      const selectedProduct = productOptions.find(p => p.name === productName);
      if (selectedProduct) {
        setProducts(products.map(p =>
          p.key === key ? { ...p, product: productName, price: selectedProduct.price } : p
        ));
      }
    };

    const handleSubmitAndPrint = async (values) => {
      try {
        const stockResponse = await fetch('https://chalan.eoptilab.com/backend/get_product_stock.php');
        const stockResult = await stockResponse.json();
        if (!stockResult.success) {
          throw new Error(stockResult.message);
        }

        const stockMap = new Map(stockResult.data.map(product => [product.name, product.quantity]));

        for (const product of products) {
          const availableStock = stockMap.get(product.product) || 0;
          if (product.quantity > availableStock) {
            notification.error({
              message: 'Error',
              description: `Insufficient stock for product ${product.product}. Available quantity: ${availableStock}.`,
            });
            return;
          }
        }

        const invoiceResponse = await fetch('https://chalan.eoptilab.com/backend/add_invoice.php', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            invoiceNumber: invoiceNumber,
            customer: values.customer,
            address: values.address,
            state: values.state,
            defaultDiscount: values.default_discount,
            category: values.category,
            number: values.number,
            totalAmount: totalAmount,
            products,
            narration: values.narration,
            gstAmount: gstAmount, // Replace gst_percentage with gst_amount
            invoiceDate: invoiceDate ? invoiceDate.format('YYYY-MM-DD') : null,
            forInvoiceNo: forInvoiceAmount,
            froInvoiceAmount: froInvoiceAmount,
            difference_amount: differenceAmount

          }),
        });

        const invoiceResult = await invoiceResponse.json();

        if (!invoiceResult.success) {
          throw new Error(invoiceResult.message);
        }

        await Promise.all(products.map(async (product) => {
          const productUpdateResponse = await fetch('https://chalan.eoptilab.com/backend/update_product.php', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              name: product.product,
              quantity: -product.quantity,
            }),
          });

          const productUpdateResult = await productUpdateResponse.json();

          if (!productUpdateResult.success) {
            throw new Error(productUpdateResult.message);
          }
        }));

        // Increment invoice number only if it's in the expected format
        const incrementInvoiceNumber = (currentInvoiceNumber) => {
          const match = currentInvoiceNumber.match(/^Challan(\d+)$/);
          if (match) {
            const nextNumber = (parseInt(match[1], 10) + 1).toString().padStart(4, '0');
            return `Challan${nextNumber}`;
          }
          return currentInvoiceNumber;
        };

        const newInvoiceNumber = incrementInvoiceNumber(invoiceNumber);
        localStorage.setItem('invoiceNumber', newInvoiceNumber);
        setInvoiceNumber(newInvoiceNumber);

        notification.success({
          message: 'Success',
          description: 'Invoice added and inventory updated successfully',
        });

        printInvoice();
        form.resetFields();
        setProducts([]);
        setInvoiceDate(moment());  // Reset to current date

      } catch (error) {
        notification.error({
          message: 'Error',
          description: 'An unexpected error occurred: ' + error.message,
        });
      }
    };

    const printInvoice = () => {
      const invoiceHtml = `
        <!DOCTYPE html>
        <html lang="en">
        <head>
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <title>Invoice</title>
            <style>
                @page {
                    size: A4;
                    margin: 20mm;
                }
                body {
                    font-family: Arial, sans-serif;
                    color: #000;
                    margin: 0;
                    padding: 0;
                    box-sizing: border-box;
                    background-color: #f4f4f4;
                }
                .container {
                    width: 100%;
                    max-width: 800px;
                    margin: 0 auto;
                    padding: 20px;
                    border: 1px solid #ddd;
                    background: #fff;
                    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
                    position: relative;
                    border-radius: 8px;
                }
                .header {
                    text-align: center;
                    margin-bottom: 20px;
                    border-bottom: 2px solid #000;
                    padding-bottom: 10px;
                }
                .header img {
                    max-width: 120px;
                }
                .header h1 {
                    margin: 10px 0;
                    font-size: 26px;
                    color: #333;
                }
                .company-details, .invoice-details {
                    margin-bottom: 20px;
                    font-size: 14px;
                }
                .company-details p, .invoice-details p {
                    margin: 5px 0;
                }
                .company-details {
                    border-bottom: 1px solid #ddd;
                    padding-bottom: 10px;
                }
                .invoice-details {
                    border-bottom: 1px solid #ddd;
                    padding-bottom: 10px;
                }
                .table-container {
                    margin-bottom: 40px;
                }
                table {
                    width: 100%;
                    border-collapse: collapse;
                    font-size: 14px;
                    margin-bottom: 20px;
                }
                table, th, td {
                    border: 1px solid #ddd;
                }
                th, td {
                    padding: 10px;
                    text-align: left;
                }
                th {
                    background-color: #f4f4f4;
                    font-weight: bold;
                }
                .total-row {
                    font-weight: bold;
                    background-color: #f4f4f4;
                    text-align: right;
                    border-top: 2px solid #000;
                }            .footer {
                    font-size: 12px;
                    text-align: center;
                    margin-top: 20px;
                    padding-top: 10px;
                    border-top: 1px solid #ddd;
                }
                .footer p {
                    margin: 5px 0;
                    color: #666;
                }
                .amount-words {
                    font-style: italic;
                    font-size: 12px;
                    margin-top: 10px;
                    text-align: left;
                }
                .signatory {
                    margin-top: 40px;
                    text-align: right;
                    font-size: 12px;
                }
                .qr-code {
                    position: absolute;
                    bottom: 20px;
                    left: 20px;
                    max-width: 100px;
                }
            </style>
        </head>
        <body>
            <div class="container">
                <!-- Header with Company Logo and Title -->
                <div class="header">
                    <h1>Challan</h1>
                </div>
                <!-- Invoice Details -->
                <div class="invoice-details">
                    <p><strong>Challan Number:</strong> ${invoiceNumber}</p>
                    <p><strong>Date:</strong> ${invoiceDate ? invoiceDate.format('DD-MMM-YY') : ''}</p>
                    <p><strong>Customer:</strong> ${form.getFieldValue('customer')}</p>
                    <p><strong>Address:</strong> ${form.getFieldValue('address')}</p>
                    <p><strong>State:</strong> ${form.getFieldValue('state')}</p>
                    <p><strong>Phone Number:</strong> ${form.getFieldValue('number')}</p>
                    <p><strong>Narration:</strong> ${form.getFieldValue('narration')}</p>
                            <p><strong>For Invoice Number:</strong> ${forInvoiceAmount}</p>
        <p><strong>Invoice Amount:</strong> ${froInvoiceAmount.toFixed(2)}</p>

                </div>
                <!-- Items Table -->
                <div class="table-container">
                    <table>
                        <thead>
                            <tr>
                                <th>Product</th>
                                <th>Quantity</th>
                                <th>Price</th>
                                <th>Discount</th>
                                <th>Category</th>
                                <th>GST Amount</th>
                                <th>Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${products.map(product => {
        const price = parseFloat(product.price) || 0;
        const quantity = parseInt(product.quantity, 10) || 0;
        const total = (quantity * price).toFixed(2);
        return `
                                    <tr>
                                        <td>${product.product}</td>
                                        <td>${quantity}</td>
                                        <td>${price.toFixed(2)}</td>
                                        <td>${form.getFieldValue('default_discount')}</td>
                                        <td>${form.getFieldValue('category')}</td>
                <td>${gstAmount.toFixed(2)}</td>
                                        <td>${total}</td>
                                    </tr>
                                `;
      }).join('')}
                            <tr class="total-row">
                                <td colspan="3">Total Amount</td>
                                <td>${totalAmount.toFixed(2)}</td>
                                                                <td colspan="3">Difference</td>

                                        <td> ${differenceAmount.toFixed(2)}</td>

                            </tr>
                        </tbody>
                    </table>
                    <!-- Amount in Words -->


                  <!-- Footer -->
                  <div class="footer">
                      <p>This is a Computer Generated Invoice</p>
                  </div>

              </div>
        </body>
        </html>
        `;

      const printWindow = window.open('', '', 'height=800,width=600');
      printWindow.document.write(invoiceHtml);
      printWindow.document.close();
      printWindow.print();
    };


    return (
      <div>
        <Title level={2}>Challan</Title>
        <Form form={form} onFinish={handleSubmitAndPrint} layout="vertical">
          <Row gutter={16}>
            <Col span={6}>
              <Form.Item label="Invoice Number">
                <Input
                  value={invoiceNumber}
                  onChange={(e) => setInvoiceNumber(e.target.value)}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
            <Form.Item name="customer" label="Customer Name" rules={[{ required: true }]}>
              <Select
                showSearch
                placeholder="Select or type a customer"
                onChange={handleCustomerChange}
                onSearch={handleSearchCustomer}
                filterOption={false}
              >
                {filteredCustomerOptions.map(customer => (
                  <Option key={customer.name} value={customer.name}>
                    {customer.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            </Col>
            {customerAccounts.length > 1 && (
            <Col span={6}>
              <Form.Item name="accessories" label="Accessories Category" rules={[{ required: true }]}>
                <Select
                  placeholder="Select accessories category"
                  onChange={handleAccessoriesChange}
                >
                  {customerAccounts.map(account => (
                    <Option key={account.category} value={account.category}>
                      {account.category}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          )}


            <Col span={6}>
              <Form.Item name="address" label="Address">
                <Input />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="number" label="Contact Number">
                <Input />
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item name="state" label="State">
                <Input />
              </Form.Item>
            </Col>

            <Col span={6}>
              <Form.Item label="Invoice Date">
                <DatePicker
                  value={invoiceDate}
                  onChange={date => setInvoiceDate(date)}
                  format="YYYY-MM-DD"
                  style={{ width: '100%' }}
                />
              </Form.Item>
            </Col>

          </Row>



          <Divider />

          {products.map((product) => (
            <Form.Item key={product.key} style={{ marginBottom: 0 }}>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                <Form.Item label="Product" style={{ flex: 2, marginBottom: 0 }}>
                  <Select
                    value={product.product}
                    onChange={value => handleProductSelect(product.key, value)}
                    onSearch={handleSearch}
                    showSearch
                    filterOption={false} // Disable default filtering
                    placeholder="Select or type a product"
                    style={{ width: '100%' }}
                    dropdownStyle={{ width: 300 }} // Adjust the width of the dropdown menu if needed
                    notFoundContent={null} // Hide the "Not Found" content
                  >
                    {filteredProductOptions.map(option => (
                      <Option key={option.name} value={option.name}>
                        {option.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item label="Quantity" style={{ marginLeft: '5px', marginBottom: 0 }}>
                  <InputNumber
                    value={product.quantity}
                    onChange={value => handleProductChange(product.key, 'quantity', value)}
                    min={1}
                    placeholder="Quantity"
                  />
                </Form.Item>
                <Form.Item label="Price" style={{ marginLeft: '5px', marginBottom: 0 }}>
                  <InputNumber
                    value={product.price}
                    onChange={value => handleProductChange(product.key, 'price', value)}
                    min={0}
                    step={0.01}
                    placeholder="Price"
                  />
                </Form.Item>
                <Form.Item label="Total" style={{ flex: 1, marginLeft: '5px', marginBottom: 0 }}>
                  <Input
                    value={(product.quantity * product.price).toFixed(2)}
                    readOnly
                    placeholder="Total"
                  />
                </Form.Item>
              <Form.Item name="default_discount" label="Discount" style={{ flex: 1, marginLeft: '5px', marginBottom: 0 }} >
                <Input />
              </Form.Item>  <Form.Item name="category" label="Category" style={{ flex: 1, marginLeft: '5px', marginBottom: 0 }} >
                <Input />
              </Form.Item>

                <Form.Item label=" " style={{ marginLeft: '5px', marginBottom: 0 }}>
                  <Button
                    type="primary" // Use primary for a prominent color, or customize style
                    danger
                    onClick={() => handleRemoveProduct(product.key)}
                  >
                    Remove
                  </Button>
                </Form.Item>
              </div>
            </Form.Item>
          ))}

          <Button type="dashed" onClick={addProduct} style={{ width: '100%', marginBottom: '10px' }}>
            Add Product
          </Button>


          <Form.Item label="GST Amount">
        <InputNumber
          value={gstAmount}
          onChange={value => setGstAmount(value)}
          min={0}
          step={0.01}
          style={{ width: '100%' }}
        />
      </Form.Item>
          <Form.Item name="narration" label="Narration">
            <Input  />
          </Form.Item>
          <Col span={12}>
          <Form.Item label="For Invoice Number">
  <Input
    value={forInvoiceAmount}
    onChange={(e) => setForInvoiceAmount(e.target.value)} // Access the input's value
    style={{ width: '100%' }}
  />
</Form.Item>
          </Col> <Col span={12}>
            <Form.Item label="For Invoice Amount">
              <InputNumber
                value={froInvoiceAmount}
                onChange={value => setFroInvoiceAmount(value)}
                min={0}
                step={0.01}
                style={{ width: '100%' }}
              />
            </Form.Item>
          </Col>
          <Form.Item>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: 'bold' }}>
              <div>Total Amount:</div>
              <div>{totalAmount.toFixed(2)}</div>
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 'bold', marginBottom: '8px' }}>Difference Amount:</div>
              <div style={{ color: differenceAmount < 0 ? '#ff4d4f' : '#52c41a' }}>
                {differenceAmount.toFixed(2)}
              </div>
            </div>
          </Form.Item>
          <Button type="primary" htmlType="submit" style={{ width: '10%' }}>
            Generate Invoice
          </Button>
        </Form>
      </div>

    );
  };

  export default InvoiceForm;
